import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@afosto/app-components-react/Dialog';
import { startPlacing } from '../../../utils/handlingList';
import translations from './translations';

const FinishedUnpackingDialog = ({ isOpen, shipment }) => {
  const history = useHistory();
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  const handlePutAway = async () => {
    try {
      await startPlacing({ shipment, handlingListID: shipment.list_id, history });
    } catch (err) {
      enqueueSnackbar(intl.formatMessage(translations.feedback.putAwayFailed), {
        variant: 'error',
      });
      history.push(`/shipments/${shipment.id}/items`);
    }
  };

  const handleKeepUnpacking = () => {
    history.push('/shipments');
  };

  return (
    <Dialog open={isOpen} maxWidth="xs">
      <DialogTitle>
        <FormattedMessage {...translations.title} />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormattedMessage {...translations.message} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="outlined" onClick={handleKeepUnpacking}>
          <FormattedMessage {...translations.actions.keepUnpacking} />
        </Button>
        <Button color="primary" variant="contained" onClick={handlePutAway}>
          <FormattedMessage {...translations.actions.putAway} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

FinishedUnpackingDialog.propTypes = {
  isOpen: PropTypes.bool,
  shipment: PropTypes.object,
};

FinishedUnpackingDialog.defaultProps = {
  isOpen: false,
  shipment: undefined,
};

export default FinishedUnpackingDialog;
